import Vue from 'vue'

const state = {
  processes: []
}

const getters = {
  hasActiveProcesses: (state) => {
    return state.processes.length > 0
  }
}

const mutations = {
  UPSERT_PROCESS: (state, { reportId, updates }) => {
    const index = state.processes.findIndex((p) => p.reportId === reportId)
    if (index === -1) {
      state.processes.push({ reportId, ...updates })
      return
    }
    Vue.set(state.processes, index, {
      ...state.processes[index],
      ...updates
    })
  },
  REMOVE_PROCESS: (state, { reportId }) => {
    state.processes = state.processes.filter((p) => p.reportId !== reportId)
  }
}

const actions = {
  updateProgress({ commit }, { reportId, processed, total, percentage }) {
    commit('UPSERT_PROCESS', {
      reportId,
      updates: { processed, total, percentage }
    })
  },
  clearProcess({ commit }, { reportId }) {
    commit('REMOVE_PROCESS', { reportId })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
